<template>
  <section>
    <!-- 中心动态 -->
    <v-sub_banner :msgObj="subBannerInfo"></v-sub_banner>
    <b-container fluid>
      <b-row class="justify-content-center newCenter">
        <b-col cols="12" sm="10" md="9" xl="7">
          <div class="centerBox">
            <div
              class="itemNew"
              @click="goDetail(item)"
              v-for="(item, index) in newsData"
              :key="index"
            >
              <div class="newsImg"><img :src="item.img" alt="" /></div>
              <div class="text">
                <h3>{{ item.name }}</h3>
                <p style="text-align: justify">{{ item.introduction }}</p>
                <p class="time">发布：{{ item.time}}</p>
              </div>
            </div>
          </div>
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :pager-count="5"
            @current-change="handleChange"
          >
          </el-pagination>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>
<script>
import Sub_banner from "../sub-banner.vue";
import qs from "qs";
import axios from "axios";
import utils from "@/utils/commonUrl.js";
export default {
  components: {
    "v-sub_banner": Sub_banner,
  },
  data() {
    return {
      subBannerInfo: {
        img: require("@/assets/images/connect_banner.png"),
        title: "中心动态",
        subTitle: "News",
      },
      currentPage: "1",
      // pageSize: '5',
      newsData: [],
      newsData1: [
        {
          id: "1",
          img: require("@/assets/images/index/news1.png"),
          name: "民航局信息中心党支部联合组织开展“四史”专题学习培训",
          introduction:
            "为深入贯彻落实习近平总书记关于深入学习党史、新中国史、改革开放史、社会主义发展史的重要指示批示精神，11月30日，民航局信息中心第二党支部联合第一党支部、第三党支部组织开展“四史”专题学习培训暨主题党日活动，邀请中共民航局党校教授作了“四史”专题学习导读。",
          time: "2021-12-03",
        },
        {
          id: "2",
          img: require("@/assets/images/index/news2.png"),
          name: "柳芳赴民航局信息中心调研",
          introduction:
            "11月30日，民航局党组成员柳芳赴信息中心调研，现场了解民航电子政务中心机房建设情况，听取信息中心工作汇报，就信息中心下一步推进民航强国国际化战略提出指导意见。",
          time: "2021-12-01",
        },
        {
          id: "3",
          img: require("@/assets/images/index/news3.png"),
          name: "适航审定运行管理系统顺利通过项目终验评审",
          introduction:
            "2021年10月29日，信息中心组织召开适航审定运行管理系统项目终验评审会。民航局适航司、中国航协、管干院、北京航空航天大学等单位参加本次评审。",
          time: "2021-11-08",
        },
      ],
      total: 0,
      currentPage: 1,
      queryInfo: {
        currentPage: 1,
        pageSize:10
      },
    };
  },
  watch: {},
  created() {
    this.getNewsList();
  },
  mounted() {
    // 窗口大小发生改变时,调用一次
    window.onresize = () => {
      let screenWidth = window.innerWidth;
      this.setReSize(screenWidth);
    };
    this.setReSize(window.innerWidth);
  },
  methods: {
    async getNewsList() {
      try {
        const { data: res } = await this.$http.get(
          "/server/api/content/news/website/search/getPageList",
          {
            params: this.queryInfo,
          }
        );
        
        
        if (res.code == 200) {
          this.total = res.content.total;
          this.newsData = res.content.list;
          this.newsData.forEach((item, index) => {
            item.time = this.formate_Date(item.time)
            console.log(";;;",item.time);
            item.img =
              utils.imgURL + "/server/api/system/file/getFile?id=" + item.fileCoverId;
          });
        }
      } catch (e) {
        return false;
      }
    },
    
    setReSize(screenWidth) {
      if (screenWidth > 576) {
        this.subBannerInfo.img = require("@/assets/images/connect_banner.png");
      } else {
        this.subBannerInfo.img = require("@/assets/images/common_m.png");
      }
    },
    goDetail(val) {
     
      if (!val.url) {
        // let routeData = "";
        // routeData = this.$router.resolve({
        //   path: `/about-us/new-detail`,
        //   query: {
        //     id: val.id,
        //     type: this.activeName,
        //   },
        // });
        // window.open(routeData.href, "_blank");
        this.$router.push({
          path: `/about-us/new-detail`,
          query: {
            id: val.id,
            type: this.activeName,
          },
        })
      } else {
        let urlStr = "";
        urlStr = val.url.indexOf("http") == -1 ? "https://" + val.url : val.url;
        window.open(urlStr);
      }
    },

    formate_Date(time) {
      time = new Date(time);
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();

      if (month < 10) {
        month = "0" + month;
      }

      if (day < 10) {
        day = "0" + day;
      }
      return year + "-" + month + "-" + day + "";
    },
    handleChange(val) {
      // console.log("当前页", val);
      this.currentPage = val;
      this.queryInfo.currentPage = val;
      this.getNewsList();
    },
  },
};
</script>
<style scoped>
@import "../../assets/css/newCenter.css";
</style>
<style lang="less" scoped>
  .itemNew:hover h3{
    color: #409eff;
  } 
@media (max-width: 575px) {
  .el-pagination {
    // padding: 0 50px;
    // box-sizing: border-box;
  }
  .centerBox {
    // padding-left: 40px;
    // padding-right: 40px;
    padding: 40px 40px 0px;
  }
  .itemNew {
    flex-direction: column;
    margin-bottom: 40px;
    .newsImg {
      width: 100%;
      // height: 150px;
    }
    .text {
      h3 {
        font-size: 15px;
        line-height: 1.7;
        margin-bottom: 14px;
        text-align: left;
      }
      p {
        font-size: 14px;
        line-height: 1.8;
        text-align: left;
      }
      .time {
        // text-align: left;
        display: flex;
        justify-content: flex-end;
      }
    }
  }
}
@media (min-width: 576px) and (max-width: 767px) {
  .itemNew {
    margin-bottom: 50px;
    // flex-direction: column;
    .newsImg {
      width: 35%;
      // height: 150px;
    }
    .text {
      h3 {
        font-size: 17px;
        line-height: 1.6;
        margin-bottom: 14px;
        text-align: left;
      }
      p {
        font-size: 14px;
        line-height: 2;
        text-align: left;
      }
      .time {
        display: flex;
        justify-content: flex-end;
      }
    }
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .itemNew {
    margin-bottom: 50px;
    // flex-direction: column;
    .newsImg {
      width: 40%;
    }
    .text {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      h3 {
        font-size: 18px;
        line-height: 1.9;
        margin-bottom: 10px;
        text-align: left;
      }
      p {
        font-size: 15px;
        line-height: 2;
        text-align: left;
      }
      .time {
        display: flex;
        justify-content: flex-end;
      }
    }
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .itemNew {
    margin-bottom: 50px;
    // flex-direction: column;
    .newsImg {
      width: 35%;
    }
    .text {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      h3 {
        font-size: 18px;
        line-height: 1.8;
        margin-bottom: 10px;
        text-align: left;
      }
      p {
        font-size: 14px;
        line-height: 2;
        text-align: left;
      }
      .time {
        display: flex;
        justify-content: flex-end;
      }
    }
  }
}
@media (min-width: 1200px) {
  .itemNew {
    // flex-direction: column;
    .newsImg {
      // width: 35%;
    }
    .text {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      h3 {
        font-size: 21px;
        line-height: 1.8;
        margin-bottom: 10px;
        text-align: left;
      }
      p {
        font-size: 15px;
        line-height: 2;
        text-align: left;
      }
      .time {
        display: flex;
        justify-content: flex-end;
      }
    }
  }
}
</style>
